var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        "append-to-body": "",
        width: "50%"
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "orgForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "110px",
            disabled: _vm.disabled
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "公证事项", prop: "matter" } },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.ruleForm.matter,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "matter", $$v)
                    },
                    expression: "ruleForm.matter"
                  }
                },
                _vm._l(_vm.checkboxList, function(item, index) {
                  return _c("el-checkbox", {
                    key: index,
                    attrs: { label: item.label, name: "matter" }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "份数", prop: "name" } },
            [
              _c("el-input-number", {
                attrs: { size: "small", min: 1, label: "描述文字" },
                model: {
                  value: _vm.ruleForm.num,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "num", $$v)
                  },
                  expression: "ruleForm.num"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("ruleForm")
                    }
                  }
                },
                [_vm._v("保存")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.resetForm("ruleForm")
                    }
                  }
                },
                [_vm._v("重置")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }